import { useQuery } from '@apollo/client';
import { GET_SCORECARD_CONFIGURATION, ScorecardConfigurationResponse } from '../api';
import { useSelector } from 'react-redux';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';

export function useFinanceProgramDataFetch(isReadOnly = false) {
  const isPrescreenScorecardBuilderHidden = useSelector(
    portalConfigurationsSelectors.isPrescreenScorecardBuilderHidden
  );

  const { data: scorecardConfigurationData, loading } = useQuery<ScorecardConfigurationResponse>(
    GET_SCORECARD_CONFIGURATION,
    {
      skip: isPrescreenScorecardBuilderHidden || isReadOnly,
    }
  );

  return {
    isLoading: loading,
    scorecardConfig: scorecardConfigurationData?.scoreCard?.[0],
  };
}
